import type { HeroSection } from '@/data/types';
import { resolveImagePath } from '@/utils/imageMap';

interface HeroProps {
  data: HeroSection;
}

export function Hero({ data }: HeroProps) {
  const backgroundImageUrl = resolveImagePath(data.backgroundImage);

  return (
    <section 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center"
      style={{
        backgroundImage: `url('${backgroundImageUrl}')`
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40"></div>
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          {data.title}
        </h1>
        
        {data.subtitle && (
          <p className="text-lg md:text-xl text-white mb-8 leading-relaxed max-w-2xl mx-auto">
            {data.subtitle}
          </p>
        )}
        
        {data.ctaButton && (
          <a
            href={data.ctaButton.href}
            className="inline-block bg-cyan-400 hover:bg-cyan-500 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-300 text-lg shadow-lg"
          >
            {data.ctaButton.text}
          </a>
        )}
      </div>
    </section>
  );
}